<template>
  <el-dialog
    :visible.sync="dialogVisible"
    custom-class="zyyj-dialog"
    :close-on-click-modal="false"
    :show-close="false"
    :modal-append-to-body="false"
    @open="handleOpen"
  >
    <img
      src="../../assets/big-screen/close-window.png"
      class="close"
      alt="close-window"
      @click="closeDialog"
    />
    <div class="detail-container">
      <div class="title">
        <img src="../../assets/big-screen/city-basic-left.png" alt="" />
        <span class="title-font"
          >{{ this.disData.schoolName }}基本情况统计</span
        >
        <img src="../../assets/big-screen/city-basic-right.png" alt="" />
      </div>
      <div class="data">
        <el-row>
          <el-col :span="4">
            <span>班级(总数)</span>
            <p style="margin-top: 10px">
              <span class="data-font">{{ disData.totalClassCount || 0 }}</span>
              <span>个</span>
            </p>
          </el-col>
          <el-col :span="4" v-if="!$regional.HengshuiYanshou">
            <span>班级(55人以上)</span>
            <p style="margin-top: 10px">
              <span class="special-data-font">{{
                disData.largeClassCount || 0
              }}</span>
              <span>个</span>
            </p>
          </el-col>
          <el-col :span="4">
            <span>教师</span>
            <p style="margin-top: 10px">
              <span class="data-font">{{ disData.teacherCount || 0 }}</span>
              <span>人</span>
            </p>
          </el-col>
          <el-col :span="4">
            <span>学生</span>
            <p style="margin-top: 10px">
              <span class="data-font">{{ disData.studentCount || 0 }}</span>
              <span>人</span>
            </p>
          </el-col>
          <el-col :span="4">
            <span>男生</span>
            <p style="margin-top: 10px">
              <span class="data-font">{{ disData.boyCount || 0 }}</span>
              <span>人</span>
            </p>
          </el-col>
          <el-col :span="4">
            <span>女生</span>
            <p style="margin-top: 10px">
              <span class="data-font">{{ disData.girlCount || 0 }}</span>
              <span>人</span>
            </p>
          </el-col>
        </el-row>
      </div>
      <div class="table-container">
        <div>
          <span class="table-title">班级人员统计</span>
          <el-select
            placeholder="请选择"
            size="medium"
            class="grade"
            v-model="grade"
            @change="changeGrade"
            :popper-append-to-body="false"
          >
            <el-option
              v-for="item in grades"
              :key="item.value"
              :label="item.name"
              :value="item.value"
            ></el-option>
          </el-select>
        </div>
        <div>
          <el-row>
            <el-col :span="24">
              <el-table
                :data="analysis"
                size="medium"
                :header-row-style="{ color: '#fff' }"
                :row-style="{ height: '40px' }"
                class="home-table"
              >
                <el-table-column prop="id" label="序号" width="120">
                  <template slot-scope="scope">
                    {{ scope.$index + 1 }}
                  </template>
                </el-table-column>
                <el-table-column prop="className" label="班级">
                </el-table-column>
                <el-table-column prop="studentNumber" label="班级人数">
                  <template slot-scope="scope">
                    <span
                      :class="Number(scope.row.studentNumber) > 55 ? 'red' : ''"
                      >{{ scope.row.studentNumber }}</span
                    >
                  </template>
                </el-table-column>
                <el-table-column
                  prop="boyCount"
                  label="男生数"
                ></el-table-column>
                <el-table-column
                  prop="girlCount"
                  label="女生数"
                ></el-table-column>
              </el-table>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import _ from 'lodash'
// import __ from '@/util/common-utils'
export default {
  props: ['identify', 'visible', 'grades', 'disData'],
  data() {
    return {
      grade: '',
      analysis: [],
      submitting: false,
      isLastSuccessful: false
    }
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible === true
      },
      set() {
        this.$emit('update:visible', false)
      }
    },

    _() {
      return _
    }
  },
  mounted() {},
  methods: {
    handleOpen() {
      this.submitting = false
      this.grade = this.grades[0].value
      this.$xhrGet(`/acc/summary/school/grade/${this.grades[0].value}`, {
        schoolId: this.disData.schoolId
      }).then(rs => {
        this.analysis = rs.data
      })
    },

    changeGrade(val) {
      this.$xhrGet(`/acc/summary/school/grade/${val}`, {
        schoolId: this.disData.schoolId
      }).then(rs => {
        this.analysis = rs.data
      })
    },

    closeDialog() {
      if (this.isLastSuccessful) {
        this.$emit('edit-result', true)
      }
      this.$emit('update:visible', false)
    }
  }
}
</script>

<style lang="scss" scoped>
/deep/ .el-dialog {
  position: relative;
  background: url("../../assets/big-screen/dialog.png") center no-repeat;
  background-size: 100% 100%;
}
/deep/ .el-dialog__header {
  padding: 0;
  padding-bottom: 0;
}
/deep/ .el-dialog__body {
  border: none;
}
.detail-container {
  min-height: 40px;
  line-height: 20px;
  margin-bottom: 20px;
}
.title {
  height: 30px;
  margin-top: 30px;
  text-align: center;
  vertical-align: middle;
}
.title-font {
  display: inline-block;
  margin: 0 12px;
  font-size: 24px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #41f9ff;
}
.data {
  height: 60px;
  margin: 40px 0;
  padding: 20px;
  background: rgba(35, 113, 232, 0.25);
  color: #fff;
  border-radius: 2px;
}
.data-font {
  font-size: 24px;
  font-family: DIN-Medium, DIN;
  font-weight: 500;
  color: #3df9ff;
}
.special-data-font {
  font-size: 24px;
  font-family: DIN-Medium, DIN;
  font-weight: 500;
  color: #ff6666;
}
.table-title {
  font-size: 20px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #43f9ff;
}
/deep/ .el-input__inner {
  background: #184e9d;
  color: #fff;
}
/deep/ .el-table {
  background-color: rgba(35, 113, 232, 0.17);
  color: #fff;
}
.el-table /deep/ tr,
.el-table /deep/ th,
/deep/ .cell {
  background-color: transparent !important;
}
.close {
  position: absolute;
  cursor: pointer;
  right: -25px;
  top: -30px;
}
/deep/ .el-table {
  border-color: transparent !important;
}
.home-table /deep/ td {
  border-bottom: 1px solid rgba(255, 255, 255, 0.12) !important;
}
.home-table /deep/ th {
  border-bottom: 1px solid rgba(255, 255, 255, 0.12) !important;
}
// 去掉表格单元格边框
/deep/ .home-table th {
  border: none;
}
/deep/ .home-table td,
.home-table th.is-leaf {
  border: none;
}
// 表格最外边框
/deep/ .el-table--border,
.el-table--group {
  border: none;
}
// 头部边框
/deep/ .home-table thead tr th.is-leaf {
  border: none;
}
/deep/ .home-table thead tr th:nth-last-of-type(2) {
  border: none;
}
// 表格最外层边框-底部边框
/deep/ .el-table--border::after,
.el-table--group::after {
  width: 0;
}
/deep/ .home-table::before {
  width: 0;
}
/deep/ .home-table .el-table__fixed-right::before,
.el-table__fixed::before {
  width: 0;
}
// 表格有滚动时表格头边框
/deep/ .el-table--border th.gutter:last-of-type {
  border: none;
}
.red {
  color: #ff6666;
}

.grade {
  float: right;
  width: 160px;
  height: 40px;
}
/deep/ .el-select-dropdown.el-popper {
  background: #184e9d;
  .el-select-dropdown__item {
    color: #fff;
  }
  .selected {
    background: #2371e8;
    opacity: 1 !important;
  }
  .hover {
    background: #2371e8;
    opacity: 0.45;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/big-screen/SchoolDetail.vue